<template>
    <BaseView>
        <div class="bg-surface-0 dark:bg-surface-900 shadow rounded-border p-4 h-full relative m-auto">
            <Tabs value="0">
                <TabList>
                    <Tab value="0">Users</Tab>
                    <Tab value="1">Groups</Tab>
                    <Tab value="2">Roles</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel value="0">
                        <UserList/>
                    </TabPanel>
                    <TabPanel value="1">
                        <GroupList/>
                    </TabPanel>
                    <TabPanel value="2">
                        <RoleList/>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </div>
    </BaseView>
</template>
<script setup>
import GroupList from "@/src/views/user/GroupList.vue";
import UserList from "@/src/views/user/UserList.vue";
import RoleList from "./RoleList.vue";
import BaseView from "@/src/views/BaseView.vue";

import {onMounted} from 'vue';
import {useStore} from 'vuex';

const store = useStore();

onMounted(() => {
    store.dispatch('userStore/loadUsersAndGroups');
})
</script>